module.exports = __webpack_public_path__ + "media/mobile2.7cfc942b.mp4";